import axios from "axios";

// AXIOS CONFIG
const AxiosDownload = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}api`,
  responseType: "blob",
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
  withCredentials: true, // Cookie httpOnly envoyé automatiquement
});

/**
 * Suppress Content-Type on GET requests without body
 */
AxiosDownload.interceptors.request.use((request) => {
  if (request.method.toLowerCase() === "get") {
    delete request.headers["Content-Type"];
  }
  return request;
});

AxiosDownload.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default AxiosDownload;
